import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useAbility } from '../../users/AbilityContext';
import { useCanUseOfflineFeature } from './useCanUseOfflineFeature';

export const useCanUseOfflineMode = () => {
  const { isBrand } = useApplicationContext();
  const { isTeceoOfflineEnabled } = useFeatureFlag();
  const canUseOfflineFeature = useCanUseOfflineFeature();
  const ability = useAbility();

  return Boolean(
    isBrand && isTeceoOfflineEnabled && canUseOfflineFeature && ability.can('menu', 'offline'),
  );
};
